import { SerializedStyles, css } from "@emotion/react";

import theme from "../../styles/theme";

// eslint-disable-next-line import/prefer-default-export
export const info = (margin: number): SerializedStyles => css`
  margin-top: ${theme.spacing(margin)}px;
`;
